import PublicAppContainer from './PublicAppContainer';

export default PublicAppContainer;
